import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../UI/Modal';
import MediaList from '../UI/MediaList';
import FlashMessages from '../../components/UI/FlashMessages';
import MediaFilter from '../../components/Forms/MediaFilter';
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";
import {get as getWorkspaces} from '../../../store/actions/workspace';
import {
    setMediaSearchKeyword,
    setMediaType,
    selectMediaItems,
    selectMediaItemsReset,
    hideSelectModal,
    showSelectModal,
    showUploadModal,
    get as getMedia,
    destroy as destroyMedia,
    refreshFalse as refreshFalseMedia
} from '../../store/actions/media';
import BtnPrimary from "../UI/BtnPrimary";

class MediaSelectModal extends Component {
    static propTypes = {
        filterMediaTypeEnabled: PropTypes.bool,
        defaultMediaType: PropTypes.string
    };

    static defaultProps = {
        filterMediaTypeEnabled: true,
        defaultMediaType: null
    };

    constructor(props) {
        super(props);

        this.state = {
            filteredKeyword: "",
            filteredMediaType: "",
            filteredWorkspace: "",
        };

        this.onFilterChange = this.onFilterChange.bind(this);
    }

    onFilterChange(value, name) {
        this.setState({[name]: value});
    }

    componentDidMount() {
        this.props.getWorkspaces();
        this.props.getMedia();
        this.props.selectMediaItemsReset();
    }

    showMediaUploadModal(e) {
        e.preventDefault();
        this.props.showUploadModal();
        this.props.hideSelectModal();
    }

    insertSelectedMedia(event) {
        if (this.props.onInsert && (typeof (this.props.onInsert) === "function")) {
            this.props.onInsert(this.props.name, this.props.media.selectedMediaItems);
        }
        this.props.hideSelectModal();
        this.props.selectMediaItemsReset();
        event.preventDefault();
    }

    onClose() {
        if (typeof (this.props.onClose) === "function") {
            this.props.onClose();
        }
        this.props.selectMediaItemsReset();
        this.props.hideSelectModal();
        this.setState({
            filteredMediaType: "",
            filteredKeyword: "",
            filteredWorkspace: "",
        });
    }

    render() {
        const {workspace, media, maxSelectItems, name, show, defaultMediaType, filterMediaTypeEnabled} = this.props;
        let {filteredMediaType, filteredKeyword, filteredWorkspace} = this.state;

        // setting filtredMedia type if there is passed defaultMediaType
        if (!filteredMediaType && defaultMediaType && media.fileTypes) {
            if (media.fileTypes.find(item => item.id === defaultMediaType)) {
                filteredMediaType = defaultMediaType;
            }
        }

        return (
            <div className={classNamesPrefixed({'media-select-upload-modal': true})}>
                <Modal
                    showModal={(media.showMediaSelectModal && media.name === name) || show}
                    className={'media-select'}
                    title={"Insert media files"}
                    icon={"plus"}
                    onClose={() => this.onClose()}
                    outsideCLickClose={true}
                    modalHeader={
                        <Fragment>
                            <FlashMessages withContainer={true}/>

                            <MediaFilter
                                filteredMediaType={filteredMediaType}
                                filteredWorkspace={filteredWorkspace}
                                filteredKeyword={filteredKeyword}

                                onFilterChange={this.onFilterChange}

                                submitting={media.submitting}

                                fileTypes={media.fileTypes}

                                filterMediaTypeEnabled={filterMediaTypeEnabled}
                                workspace={workspace}
                            />
                        </Fragment>
                    }
                    modalFooter={
                        <div className={classNamesPrefixed({
                            'form-actions': true,
                            'media-select-form-actions': true
                        })}>
                            <BtnPrimary
                                small
                                icon="plus"
                                onClick={(event) => this.showMediaUploadModal(event)}
                            >Add new files</BtnPrimary>
                            {this.props.media && this.props.media.selectedMediaItems.length > 0 &&
                            <BtnPrimary
                                small
                                onClick={(event) => this.insertSelectedMedia(event)}
                            >{"Insert (" + this.props.media.selectedMediaItems.length + ")"}</BtnPrimary>
                            }
                        </div>
                    }
                >

                    {media.items && !media.submitting &&
                    <div className={classNamesPrefixed({
                        'media-items-select-modal': true,
                        'media-items': true
                    })}>
                        <MediaList
                            maxSelectItems={maxSelectItems}
                            editEnabled={false}
                            deleteEnabled={false}
                            selectEnabled={true}
                            filterMediaTypeEnabled={filterMediaTypeEnabled}
                            filteredWorkspace={filteredWorkspace}
                            filteredMediaType={filteredMediaType}
                            filteredKeyword={filteredKeyword}
                            clickableThumbnail={false}
                        />
                    </div>
                    }
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        workspace: state.workspace,
        media: state.media,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWorkspaces: () => dispatch(getWorkspaces()),
        getMedia: () => dispatch(getMedia()),
        destroyMedia: (id) => dispatch(destroyMedia(id)),
        refreshFalseMedia: () => dispatch(refreshFalseMedia()),
        showUploadModal: () => dispatch(showUploadModal()),
        showSelectModal: () => dispatch(showSelectModal()),
        hideSelectModal: () => dispatch(hideSelectModal()),
        selectMediaItems: (selectedItems) => dispatch(selectMediaItems(selectedItems)),
        selectMediaItemsReset: () => dispatch(selectMediaItemsReset()),
        setMediaType: (mediaType) => dispatch(setMediaType(mediaType)),
        setMediaSearchKeyword: (keyword) => dispatch(setMediaSearchKeyword(keyword))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaSelectModal)



// WEBPACK FOOTER //
// ./src/core/admin/components/Forms/MediaSelectModal.js